import * as Yup from 'yup'

export const initialCreateFormValues = {
    group_name: "",
    discount_percent: "",
    discount_value: "",
    active: "",
}

export const createFormValidationSchema = Yup.object({
    group_name: Yup.string().required('This field is required'),
})
